/**
 * Column schema for the Libraries page's table view, kept out of the component so it can be the
 * stable input to `useGridColumnPreferences` (and so a test can read it).
 *
 * Module-level identity matters: `resolveColumnOrder` returns `LIBRARIES_COLUMN_ORDER` *by
 * reference* while the user has no stored order, which is what keeps the grid's `columns` prop
 * identity stable — and MUI rebuilds its column state, discarding in-session resizes, whenever
 * that identity changes.
 */

export const LIBRARIES_LEADING_COLUMNS = ['pin', 'title'];
export const LIBRARIES_TRAILING_COLUMNS = ['menu'];

/** Pin first, identity next, management actions last. */
export const LIBRARIES_COLUMN_ORDER: readonly string[] = [
  'pin',
  'title',
  'count',
  'duration',
  'size',
  'added',
  'modified',
  'menu',
];

/**
 * The hideable columns and their default visibility. This key set is also the definition of
 * "togglable": `title`, `pin` and `menu` are absent on purpose — they are `hideable: false`, so
 * they are neither offered in the Manage-columns panel nor ever persisted.
 */
export const LIBRARIES_DEFAULT_VISIBILITY: Record<string, boolean> = {
  count: true,
  duration: true,
  size: true,
  added: true,
  modified: true,
};
